// GamePage.jsx

import React from "react";
import { useParams, Outlet, useLocation } from "react-router-dom";
import ActiveGamesDashboard from "../../components/Games/ActiveGamesDashboard/ActiveGamesDashboard";

import "./GamesPage.css";

function GamePage() {
  const location = useLocation();

  // The GamePage route should be something like /games
  // The Outlet is where the nested routes (like /games/active or /games/:gameId) will render

  // Determine if we are on the main dashboard path
  const isDashboard =
    location.pathname.endsWith("/games") ||
    location.pathname.endsWith("/games/");

  return (
    <div className="game-page">
      {/* Only show the dashboard if we are on the root /games path.
        Otherwise, let the <Outlet /> render the nested GameDetail component.
      */}
      {isDashboard && (
        <>
          <h1>Game Lobby</h1>
          <ActiveGamesDashboard />
        </>
      )}

      {/* Renders the nested route component, like GameDetail */}
      <Outlet />

      {/* Note: You might structure your routing so ActiveGamesDashboard is also 
        a route component itself, but this structure works well for a landing page.
      */}
    </div>
  );
}

export default GamePage;
